import MarketplaceService from "../../services/api/Marketplace";
import Loader from "./Loader";
import { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from 'react-router-dom';



const MARKETPLACE_PATH = "/auth/marketplace";

const MarketplaceGate = () => {
    const location = useLocation();
    const [status, setStatus] = useState("loading");
  
    useEffect(() => {
        let cancelled = false;

  
        const validate = async () => {
            try {
                const response = await MarketplaceService.validate();
  
                if (cancelled) return;
  
                if (response?.formShow === true && response?.token) {
                    sessionStorage.setItem(
                        "marketplace_token",
                        response.token
                    );
  
                    setStatus("marketplace");
                } else {
                    setStatus("allowed");
                }
  
            } catch (error) {
                console.error("Marketplace validation failed:", error);
  
                if (!cancelled) {
                    setStatus("allowed");
                }
            }
        };
  
        validate();
  
        return () => {
            cancelled = true;
        };
    }, [location.pathname]);
  
    // Show loader while validating
    if (status === "loading") {
        return <Loader message="Please wait..." />;
    }
  
    // Redirect to marketplace
    if (status === "marketplace") {
        const token = sessionStorage.getItem("marketplace_token");
        const currentToken = new URLSearchParams(location.search).get("token");
  
        if (
            location.pathname === MARKETPLACE_PATH &&
            currentToken === token
        ) {
            return <Outlet />;
        }
  
        return (
            <Navigate
                to={`${MARKETPLACE_PATH}?token=${encodeURIComponent(token)}`}
                replace
            />
        );
    }
  
    // If marketplace validation is false, redirect to login
    if (
        status === "allowed" &&
        location.pathname === MARKETPLACE_PATH
    ) {
        return <Navigate to="/auth/login" replace />;
    }
  
    return <Outlet />;
  };
  
  export default MarketplaceGate;